import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import {
  canAddJob,
  canImportJobFromSAP,
} from '../utils/permissions';

import Header from '../components/Header/Header';
import ProfileView from '../views/Profile/ProfileView';
import JobsView from '../views/Jobs/JobsView';
import AddJobView from '../views/AddJob/AddJobView';
import ImportJobView from '../views/ImportJob/ImportJobView';
import SingleJob from '../views/SingleJob/SingleJob';
import AuthenticationErrorView from '../views/AuthenticationError/AuthenticationErrorView';
import LogoutView from '../views/Logout/LogoutView';
import PageNotFoundView from '../views/PageNotFound/PageNotFoundView';

class Router extends Component {
  render() {
    const { user } = this.props;

    return (
      <BrowserRouter>
        <Fragment>
          <Header />
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/jobs" />} />
            <Route exact strict path="/jobs/" render={() => <Redirect to="/jobs" />} />
            <Route exact path="/jobs" component={props => <JobsView {...props} />} />
            <Route exact path="/profile" component={props => <ProfileView {...props} />} />
            <Route exact path="/add-job" render={() => {
              return canAddJob(user) ? <AddJobView /> : <Redirect to="/jobs" />
            }} />
            <Route exact path="/import-job" render={() => {
              return canImportJobFromSAP(user) ? <ImportJobView user={user} /> : <Redirect to="/jobs" />
            }} />
            <Route exact path="/jobs/:id" render={props => {
              const id = props.match.params.id;
              return isNaN(id) ? <Redirect to="/jobs" /> : <SingleJob {...props} />
            }} />
            <Route exact path="/authentication-error" component={props => <AuthenticationErrorView {...props} />} />
            <Route exact path="/logout" component={props => <LogoutView {...props} />} />
            <Route exact path="/jobs/notification/:id" render={props => {
              const id = props.match.params.id;
              return isNaN(id) ? <Redirect to="/jobs" /> : <SingleJob {...props} />
            }} />
            <Route path="/jobs/:id/" render={props => {
              const id = props.match.params.id;
              return <Redirect to={isNaN(id) ? "/jobs" : `/jobs/${id}`} />
            }} />
            <Route path="*" component={props => <PageNotFoundView {...props} />} />
          </Switch>
        </Fragment>
      </BrowserRouter>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(Router);



// WEBPACK FOOTER //
// ./src/Router/Router.js